import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthFacade } from '~app/app/~store/facades/auth.facade';
import { GlobalFacade } from '~app/app/~store/facades/global.facade';
import { Observable, combineLatest, from, map, of, switchMap } from 'rxjs';

export const SUBSCRIPTION_GUARD = ():
  | Observable<UrlTree | boolean>
  | boolean => {
  const authFacade = inject(AuthFacade);
  const globalFacade = inject(GlobalFacade);
  const router = inject(Router);

  return combineLatest([
    authFacade.accessToken$,
    authFacade.registeredUserData$
  ]).pipe(
    switchMap(([accessToken, registeredUserData]) => {
      if (!accessToken && !registeredUserData) {
        const currentUrl = globalFacade.routeData?.currentUrl;

        return from(router.navigateByUrl(currentUrl || '/')).pipe(
          map(() => false)
        );
      }
      return of(true);
    })
  );
};
